import Layer from './Layer';
import ShieldImage from '../images/ShieldImage';

const shieldLayer: Layer = {
  PlaneImage: ShieldImage,
  collapsedOffsetY: 0.171,
  type: 'static',
};

export default shieldLayer;
